import React from 'react';
import { motion } from 'framer-motion';

const GlassCard = ({ children, className = '', neonBorder = false, neonColor = '#00FFD1' }) => {
  return (
    <motion.div
      whileHover={{ y: -4 }}
      className={`relative backdrop-blur-xl bg-white bg-opacity-5 border border-white border-opacity-20 p-8 transition-all duration-400 ${className}`}
      style={{
        boxShadow: neonBorder 
          ? `0 0 20px ${neonColor}40, inset 0 0 20px ${neonColor}10`
          : '0 8px 32px rgba(0, 0, 0, 0.3)'
      }}
    >
      {/* Glass morphism overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-white/10 to-transparent pointer-events-none" />
      
      {/* Content */}
      <div className="relative z-10">
        {children}
      </div>
      
      {/* Neon glow effect on hover */}
      {neonBorder && (
        <div 
          className="absolute inset-0 opacity-0 hover:opacity-100 transition-opacity duration-500 pointer-events-none"
          style={{
            background: `linear-gradient(135deg, ${neonColor}05, transparent)`,
            filter: 'blur(10px)'
          }}
        />
      )}
    </motion.div>
  );
};

export default GlassCard;